import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const WorkspaceChromeContext = React.createContext({
  vibeChrome: null,
  setVibeChrome: () => {},
  sidebarCollapsed: false,
  navOpen: false,
  toggleSidebar: () => {},
  toggleNav: () => {},
  closeNav: () => {},
  sidebarWidth: 240,
  setSidebarWidth: () => {},
});

export class WorkspaceChromeProvider extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  state = {
    vibeChrome: null,
    sidebarCollapsed: false,
    navOpen: false,
    sidebarWidth: 240,
    compactNav: false,
  };

  componentDidMount() {
    this.mediaQuery = window.matchMedia('(max-width: 1100px)');
    this.handleMedia = () => {
      this.setState({ compactNav: this.mediaQuery.matches });
    };
    this.handleMedia();
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.handleMedia);
    } else if (this.mediaQuery.addListener) {
      this.mediaQuery.addListener(this.handleMedia);
    }
  }

  componentWillUnmount() {
    if (!this.mediaQuery || !this.handleMedia) return;
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.handleMedia);
    } else if (this.mediaQuery.removeListener) {
      this.mediaQuery.removeListener(this.handleMedia);
    }
  }

  setSidebarWidth = (width) => {
    const next = Math.min(420, Math.max(200, Math.round(width)));
    this.setState({ sidebarWidth: next });
  };

  setVibeChrome = (vibeChrome) => {
    this.setState({ vibeChrome });
  };

  toggleSidebar = () => {
    this.setState((prev) => ({ sidebarCollapsed: !prev.sidebarCollapsed }));
  };

  toggleNav = () => {
    this.setState((prev) => ({ navOpen: !prev.navOpen }));
  };

  closeNav = () => {
    this.setState({ navOpen: false });
  };

  render() {
    const { vibeChrome, sidebarCollapsed, navOpen, sidebarWidth, compactNav } = this.state;
    const className = [
      'layout-v2',
      sidebarCollapsed ? 'dc-sidebar-collapsed' : '',
      navOpen ? 'dc-nav-open' : '',
    ]
      .filter(Boolean)
      .join(' ');
    const style = { height: '100%' };
    if (!sidebarCollapsed && !navOpen && !compactNav) {
      style['--dc-sidebar-width'] = `${sidebarWidth}px`;
    }

    const value = {
      vibeChrome,
      setVibeChrome: this.setVibeChrome,
      sidebarCollapsed,
      navOpen,
      toggleSidebar: this.toggleSidebar,
      toggleNav: this.toggleNav,
      closeNav: this.closeNav,
      sidebarWidth,
      setSidebarWidth: this.setSidebarWidth,
    };

    return (
      <WorkspaceChromeContext.Provider value={value}>
        <div className={className} style={style}>
          {this.props.children}
        </div>
      </WorkspaceChromeContext.Provider>
    );
  }
}
